import React, { useEffect, useRef, useState } from "react";



export function Resizeable({ children, defaultWidth,minWidth,name,maxWidth,direction="row" }) {
  var ref=useRef(null)
  var width=defaultWidth
  var isColumn=direction=="column"

  if(localStorage[name]) {
    width=localStorage[name]
  }
  if(width<minWidth) {
    width=minWidth
  }
  if(width>maxWidth) {
    width=maxWidth
  }

  var startPageX
  var startWidth

  function startResize(e){    
    // set_startPos(e.pageX)
    startPageX=isColumn ? e.pageY :  e.pageX
    startWidth=parseInt(width)
    move(e)
    window.addEventListener("mouseup",stop)
    window.addEventListener('mousemove',move)
    
  }
  function stop(){
    window.removeEventListener("mouseup",stop)
    window.removeEventListener("mousemove",move)
  }
  function move(e){
    var diff=( isColumn? e.pageY : e.pageX) -startPageX
    var moveTo=startWidth+ diff
    if(moveTo<minWidth) {
      moveTo=minWidth
    }
    if(moveTo>maxWidth) {
      moveTo=maxWidth
    }
    // console.log({startPageX,startWidth,moveTo,diff})
    if(isColumn) {
      ref.current.style.height=moveTo + 'px'
      ref.current.style.minHeight=moveTo + 'px'
    } else {
      ref.current.style.width=moveTo + 'px'
      ref.current.style.minWidth=moveTo + 'px'
    }
    width=moveTo
    localStorage[name]=moveTo
    
    e.preventDefault()
    e.stopPropagation()

    return false
  }
  return <div 
    ref={ref}
    css={`
    ${isColumn ?`
      min-height:${width}px;
      height:${width}px;
    ` : `
      min-width:${width}px;
      width:${width}px;
    `}
    display:flex;
    ${isColumn ? 'flex-direction:column' : ''};
    position:relative;
    `}>
    <div css={`
    flex:1;
    overflow-${isColumn ? 'y' :  'x'}:scroll;
    `}>{children}</div>
    <div 
    ref={ref}
    onMouseDown={startResize}
    css={`
    cursor:${isColumn ? 'row' : 'col'}-resize;
    height:${isColumn ? '5px' : '100%'};
    width:${isColumn ? '100%' : '5px'};
    background-color:#e1e1e1;
    `}/>
    </div>;

}
